// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"73f63699","703":"a79633ca","787":"22934b9d"}[chunkId] + ".chunk.js";
};